import React, { useState } from 'react';
import './ContactUs.scss';
import { Button, Col, Form, Input, message, Radio, Row } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { ContactUsPost } from '../../../Network/contactUs';
import ReCAPTCHA from 'react-google-recaptcha';

const ContactUs = ({ t }) => {
  const [form] = Form.useForm();
  const [loadingAdd, setLoadingAdd] = useState(false);

  const { mutate: onAddAppointments } = useMutation({
    mutationKey: ['addAppointments'],
    mutationFn: (body) => ContactUsPost(body),
    onSuccess: (data) => {
      console.log(data, 'datawwww');
      setLoadingAdd(false);
      if (data?.validation?.length > 0) {
        message.error(data?.validation[0]);
        return false;
      }
      message.success(t.RequestSentSuccessfully);
      form.resetFields();
      setLoadingAdd(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
    },
  });

  const onFinish = (values) => {
    setLoadingAdd(true);
    const formData = new FormData();
    formData.append('topic', values?.topic);
    formData.append('name', values?.name);
    formData.append('company', values?.company);
    formData.append('email', values?.email);
    formData.append('message', values?.message);
    onAddAppointments(formData);
  };

  const dataWhatNeed = [
    { label: t.VisualReality, value: 'VR' },
    { label: t.MixedReality, value: 'MR' },
    { label: t.Augmentedreality, value: 'AR' },
    { label: 'Book a Free Consulting session', value: 'NotSure' },
  ];

  return (
    <div className="contact-us" id="contact">
      <div className="container">
        <div className="content">
          <h1 className="contact-us-title">{t.ContactUs}</h1>
          <p className="contact-us-paragraph">{t.Briefuswhatyouneed}</p>
          <Form
            name="basic"
            layout="vertical"
            className="contact-form"
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              name="topic"
              rules={[{ required: true, message: 'Please select!' }]}
              initialValue="VR"
              className="radio-select-contact-wrapper"
            >
              <Radio.Group
                style={{ width: '100%' }}
                className="radio-select-contact"
                size="large"
                options={dataWhatNeed}
              />
            </Form.Item>
            <p className="contact-form-title">{t.yourINfo}</p>
            <Row gutter={[15, 15]}>
              <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                <Form.Item
                  name="name"
                  label={t.Fullname}
                  rules={[{ required: true }]}
                >
                  <Input type="text" placeholder={t.Fullname} />
                </Form.Item>
                <Form.Item
                  name="company"
                  label={t.Company}
                  rules={[{ required: true }]}
                >
                  <Input type="text" placeholder={t.Company} />
                </Form.Item>
                <Form.Item
                  name="email"
                  label={t.CorporateEmail}
                  rules={[
                    { required: true },
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                  ]}
                >
                  <Input type="email" placeholder={t.CorporateEmail} />
                </Form.Item>
              </Col>
              <Col
                sm={24}
                md={24}
                lg={12}
                xl={12}
                xxl={12}
                className="message-col"
              >
                <Form.Item
                  name="message"
                  label={t.Whatsinyourmind}
                  style={{ width: '100%', height: '100%' }}
                >
                  <Input.TextArea
                    type="text"
                    placeholder={t.Message}
                    style={{
                      resize: 'none',
                      height: '100%',
                      width: '100%',
                    }}
                    autoSize={{ minRows: 11, maxRows: 12 }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              className="recaptcha-container"
              name="recaptcha"
              rules={[{ required: true, message: t.PleaseCompleteCaptcha }]}
            >
              <ReCAPTCHA sitekey="6LdJPSAqAAAAAHBQK0F1Y5lXUPfPJ-3RL5mi2xGX" />
            </Form.Item>
            <div className="btn-hero">
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {t.Send}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
